import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Trichter-Kachel (Charts 2.0): Kopf-Kennzahl (z. B. Konversionsrate)
 * plus Mini-Trichter — je Phase ein schmaler Balken in ihrer Ramp-Stufe,
 * Breite relativ zur größten Stufe, Anzahl direkt am Balkenende.
 * Beantwortet „wo bleiben die Leads hängen?" statt nur „wie viel Prozent?".
 *
 *   value – Kopf-Kennzahl (fertig formatiert, z. B. „12,5 %")
 *   steps – [{ key, label, count, color }] in Phasen-Reihenfolge
 *           (count = „hat diese Phase mindestens erreicht")
 */
export default function FunnelTile({ label, value, steps, onStepClick }) {
  const max = Math.max(...steps.map((s) => s.count), 1);
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minWidth: 0 }}>
      {/* Kopf schrumpft nie — bei knapper Kachelhöhe gibt der Stufen-Bereich nach */}
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 550, fontSize: '0.82rem', lineHeight: 1.5, flexShrink: 0 }} noWrap>
        {label}
      </Typography>
      <Typography sx={{ fontSize: '1.35rem', fontWeight: 700, color: 'text.primary', fontVariantNumeric: 'tabular-nums', lineHeight: 1.2, flexShrink: 0 }}>
        {value}
      </Typography>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 0.4, mt: 0.5 }}>
        {steps.map((s) => (
          <Box key={s.key} onClick={onStepClick ? () => onStepClick(s.key) : undefined}
            sx={{
              display: 'grid', gridTemplateColumns: '72px 1fr 22px', alignItems: 'center', gap: 1,
              fontSize: '0.72rem', lineHeight: 1.15, cursor: onStepClick ? 'pointer' : 'default',
              borderRadius: 1, '&:hover': onStepClick ? { bgcolor: 'action.hover' } : {},
            }}>
            <Typography component="span" noWrap sx={{ fontSize: 'inherit', lineHeight: 'inherit', color: 'text.secondary', fontWeight: 550, textAlign: 'right' }}>
              {s.label}
            </Typography>
            <Box sx={{ minWidth: 0 }}>
              <Box sx={{
                height: 11, width: `${Math.max((s.count / max) * 100, s.count ? 6 : 0)}%`,
                bgcolor: s.color, borderRadius: '0 4px 4px 0',
              }} />
            </Box>
            <Typography component="span" sx={{ fontSize: 'inherit', lineHeight: 'inherit', color: 'text.primary', fontWeight: 650, fontVariantNumeric: 'tabular-nums' }}>
              {s.count}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
